/** @jsx jsx */

import { ReactNode } from 'react';

import { jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Grid, Margin, Select, SelectItem, Text } from '@zapier/design-system';

type DropdownItemType = {
  label: string;
  value: string;
  isDisabled?: boolean;
  iconAfter?: ReactNode;
};

type DropdownType = {
  title: string;
  items: Array<DropdownItemType>;
  value?: string;
  onSetValue: (value: DropdownItemType) => void;
};

type Props = {
  leftDropdown: DropdownType;
  rightDropdown: DropdownType;
};

const DoubleDropdowns = (props: Props) => {
  const { leftDropdown, rightDropdown } = props;

  return (
    <Grid alignItems="center" columns="2fr 0.5fr 2fr" gap={10}>
      <Grid columns={1} gap={20}>
        <Text tag="h3" type="Title">
          {leftDropdown.title}
        </Text>
        <Select
          isLabelHidden={true}
          label={leftDropdown.title}
          onChange={key => {
            const item = leftDropdown.items.find(i => i.value === key);
            if (item) {
              leftDropdown.onSetValue(item);
            }
          }}
          placeholder={leftDropdown.value ? leftDropdown.value : 'Pick One'}
          selectedKey={leftDropdown.value ?? null}
        >
          {leftDropdown.items.map(item => (
            <SelectItem
              key={item.value}
              // textValue is required because child is not a string
              textValue={item.value}
              value={item.value}
            >
              {item.label}
              {item.iconAfter}
            </SelectItem>
          ))}
        </Select>
      </Grid>
      <Margin margin="35px auto 0px">
        <Icon name="arrowBigRight" size={24} />
      </Margin>
      <Grid columns={1} gap={20}>
        <Text tag="h3" type="Title">
          {rightDropdown.title}
        </Text>
        <Select
          isLabelHidden={true}
          label={rightDropdown.title}
          onChange={key => {
            const item = rightDropdown.items.find(i => i.value === key);
            if (item) {
              rightDropdown.onSetValue(item);
            }
          }}
          placeholder={rightDropdown.value ? rightDropdown.value : 'Pick One'}
          selectedKey={rightDropdown.value ?? null}
        >
          {rightDropdown.items.map(item => (
            <SelectItem
              key={item.value}
              // textValue is required because child is not a string
              textValue={item.value}
              value={item.value}
            >
              {item.label}
              {item.iconAfter}
            </SelectItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );
};

export default DoubleDropdowns;
